module.exports = __webpack_public_path__ + "1891ebe46d50d7eff6b65c3b0417aaf6.MP3";